/**
 * @fileoverview Automation indicator chip (MOR-736)
 *
 * A small amber ⚡ chip shown next to a task title when one or more automation
 * rules target it. Mirrors the workflow editor's indicator so the task board,
 * list view, and workflow editor all read the same. Lives in its own module so
 * both the list view and the board card can import it without a cycle.
 */

import { Zap } from "lucide-react";
import { cn } from "@/utils/misc";

/** An automation rule that targets a task, for the ⚡ row indicator. */
export interface RowAutomation {
  name: string;
  summary: string;
}

export function AutomationChip({
  automations,
  className,
}: {
  automations: ReadonlyArray<RowAutomation>;
  className?: string;
}) {
  if (automations.length === 0) return null;
  return (
    <span
      className={cn(
        "inline-flex shrink-0 items-center gap-0.5 rounded-full bg-amber-100 px-1.5 py-0.5 text-[10px] font-medium text-amber-700 dark:bg-amber-900/40 dark:text-amber-400",
        className,
      )}
      title={`Automations:\n${automations.map((a) => a.summary).join("\n")}`}
      aria-label={`${automations.length} automation${
        automations.length === 1 ? "" : "s"
      } affect this task`}
    >
      <Zap className="size-3" />
      {automations.length}
    </span>
  );
}
